import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select, Space, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { getAddressFromPincode } from "../../../../apis/misc.api";
import { validateSiteAuditEnq } from "../../../../apis/pro_forma_invoice.api";

export const SITE_AUDIT_DISCOUNT = "Site Audit Discount";
export const SITE_AUDIT_DISCOUNT_AMOUNT = 999;

const NEGATIVE_CHARGE_TYPES = [
  "additional discount",
  "credit notes",
  SITE_AUDIT_DISCOUNT.toLowerCase(),
];

const isNegativeCharge = (charge_type?: string) =>
  NEGATIVE_CHARGE_TYPES.includes(String(charge_type || "").toLowerCase());

const isSiteAuditCharge = (charge_type?: string) =>
  String(charge_type || "").toLowerCase() === SITE_AUDIT_DISCOUNT.toLowerCase();

const normaliseEnqId = (value: any) => String(value || "").trim().toUpperCase();

interface PFIEditAdditionalChargesProps {
  setData: Function;
  data: any;
  pincode: string;
}

const PFIEditAdditionalCharges = ({
  setData,
  data,
  pincode,
}: PFIEditAdditionalChargesProps) => {
  const { TextArea } = Input;

  const { Option } = Select;
  const taxTypes: Array<any> = [
    {
      id: 1,
      label: "None",
      value: "none",
    },
    {
      id: 2,
      label: "CGST/SGST",
      value: "cgst_sgst",
    },
    {
      id: 4,
      label: "IGST",
      value: "igst",
    },
  ];
  const [tax_type, setTaxType] = useState("cgst_sgst");
  const [enq_status, setEnqStatus] = useState<Record<number, any>>({});

  const onFinish = (values: any) => {
    console.log("Received values of form:", values);
  };

  const validateEnq = (index: number, value: any) => {
    const enq_id = normaliseEnqId(value);
    if (!enq_id) {
      setEnqStatus((prev) => ({ ...prev, [index]: null }));
      return;
    }
    setEnqStatus((prev) => ({ ...prev, [index]: { loading: true } }));
    validateSiteAuditEnq({
      enq_id,
      estimate_id: data?.estimate_id,
      estimate_lead_id: data?.lead_id,
    }).then((res: any) => {
      setEnqStatus((prev) => ({
        ...prev,
        [index]: res
          ? { valid: res?.valid, message: res?.message }
          : {
              valid: false,
              message: "Could not validate the Site Audit ENQ ID.",
            },
      }));
    });
  };
  const onAdd = () => {
    setData("estimate_additionals", [
      ...data?.estimate_additionals,
      {
        charge_type: "Additional Charges",
        amount: 0,
        tax_value: 18,
        tax_type: tax_type,
        total: 0,
      },
    ]);
  };
  const onRemove = (index: number) => {
    var arr = [...data?.estimate_additionals];
    arr.splice(index, 1);

    setEnqStatus({});
    setData("estimate_additionals", arr);
  };
  const onChangeInput = (value: string, index: number, name: string) => {
    var arr = [...data?.estimate_additionals];
    const was_site_audit = isSiteAuditCharge(arr[index]["charge_type"]);
    arr[index][name] = value;

    const is_site_audit = isSiteAuditCharge(arr[index]["charge_type"]);

    if (is_site_audit) {
      if (name === "remark") {
        arr[index]["remark"] = normaliseEnqId(value);
      }
      arr[index]["tax_type"] = "none";
      arr[index]["tax_value"] = 0;
      arr[index]["amount"] = -SITE_AUDIT_DISCOUNT_AMOUNT;
      arr[index]["total"] = -SITE_AUDIT_DISCOUNT_AMOUNT;
      setData("estimate_additionals", [...arr]);
      return;
    }

    if (was_site_audit && name === "charge_type") {
      arr[index]["remark"] = "";
      arr[index]["amount"] = 0;
      arr[index]["total"] = 0;
      setEnqStatus((prev) => ({ ...prev, [index]: null }));
      setData("estimate_additionals", [...arr]);
      return;
    }

    const isNegative = isNegativeCharge(arr[index]["charge_type"]);
    const percentage = Number(arr[index].tax_value) || 0;

    if (name === "total") {
      // Reverse-calculate pre-tax amount from the entered final value
      const rawTotal = parseFloat(value) || 0;
      const total = isNegative ? -Math.abs(rawTotal) : Math.abs(rawTotal);
      const preTax = total / (1 + percentage * 0.01);
      arr[index]["amount"] = Number(preTax.toFixed(2));
      arr[index]["total"] = total;
    } else {
      if (name === "amount") {
        const num = Number(value);
        const safeNum = isNaN(num) ? 0 : num;
        arr[index]["amount"] = isNegative ? -Math.abs(safeNum) : Math.abs(safeNum);
      } else if (name === "charge_type" && isNegative) {
        arr[index]["amount"] = -Math.abs(Number(arr[index]["amount"]) || 0);
      } else if (name === "charge_type" && !isNegative) {
        arr[index]["amount"] = Math.abs(Number(arr[index]["amount"]) || 0);
      }

      var amount = Number(arr[index]["amount"]) || 0;
      arr[index]["total"] = Number((amount + amount * percentage * 0.01).toFixed(2));
    }

    setData("estimate_additionals", [...arr]);
  };

  useEffect(() => {
    if (pincode?.length == 6) {
      getAddressFromPincode(pincode).then((res: any) => {
        if (res?.state == "Karnataka") {
          setTaxType("cgst_sgst");
        } else {
          setTaxType("igst");
        }
      });
    }
  }, [pincode]);

  return (
    <React.Fragment>
      <div className="my-2">
        <hr />
      </div>
      <Form
        name="dynamic_form_nest_item"
        onFinish={onFinish}
        autoComplete="off"
      >
        {data?.estimate_additionals?.map((each: any, index: number) => (
          <div
            key={index.toString()}
            style={{
              marginBottom: 8,
              background: "#F9F8F6",
              borderRadius: 8,
              padding: 2,
              overflow: "scroll"
            }}
            // align="baseline"
          >
            <Space
              style={{
                display: "flex",
              }}
            >
              <Form.Item className="formItemPFIEditAdditionalCharges" style={{ minWidth: 180 }}>
                <Select
                  className="w-100"
                  onChange={(e) => {
                    onChangeInput(e, index, "charge_type");
                  }}
                  value={each.charge_type}
                  placeholder="Charge"
                >
                  {[
                    "Credit Notes",
                    "Unloading Charges",
                    "Additional Discount",
                    SITE_AUDIT_DISCOUNT,
                    "Outstation Charges",
                    "Transport Charges",
                    "Service Charges",
                  ].map((opt) => (
                    <Option key={opt} value={opt}>
                      {opt}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                className="formItemPFIEditAdditionalCharges"
                style={{ minWidth: 140 }}
              >
                <Select
                  className="w-100"
                  disabled={isSiteAuditCharge(each?.charge_type)}
                  onChange={(e) => {
                    onChangeInput(e, index, "tax_type");
                  }}
                  placeholder="Select tax type"
                  value={each?.tax_type}
                >
                  {taxTypes?.map((obj) => (
                    <Option key={obj?.id} value={obj?.value}>
                      {obj?.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                className="formItemPFIEditAdditionalCharges"
                style={{ minWidth: 120 }}
              >
                <Select
                  className="w-100"
                  disabled={isSiteAuditCharge(each?.charge_type)}
                  onChange={(e) => {
                    onChangeInput(e, index, "tax_value");
                  }}
                  placeholder="Select tax value"
                  value={each?.tax_value}
                >
                  {[0, 5, 12, 18, 28]?.map((obj) => (
                    <Option key={obj} value={obj}>
                      {obj}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item className="formItemPFIEditAdditionalCharges" style={{ minWidth: 120 }}>
                <Input
                  disabled
                  value={Math.abs(each.amount)}
                  placeholder="Pre-tax amount"
                  prefix={isNegativeCharge(each?.charge_type) ? "-₹" : "₹"}
                />
              </Form.Item>
              <Form.Item className="formItemPFIEditAdditionalCharges" style={{ minWidth: 120 }}>
                <Input
                  value={Math.abs(each?.total)}
                  disabled={isSiteAuditCharge(each?.charge_type)}
                  onChange={(e) => {
                    onChangeInput(e.target.value, index, "total");
                  }}
                  placeholder="Final (incl. tax)"
                  prefix={isNegativeCharge(each?.charge_type) ? "-₹" : "₹"}
                />
              </Form.Item>
              <MinusCircleOutlined
                onClick={() => {
                  onRemove(index);
                }}
                style={{ marginBottom: 24 }}
              />
            </Space>

            <Form.Item className="formItemPFIEditAdditionalCharges">
              {isSiteAuditCharge(each?.charge_type) ? (
                <React.Fragment>
                  <Input
                    value={each?.remark}
                    onChange={(e) => {
                      onChangeInput(e.target.value, index, "remark");
                    }}
                    onBlur={(e) => {
                      validateEnq(index, e.target.value);
                    }}
                    placeholder="Site Audit order ENQ ID"
                    addonAfter={
                      enq_status?.[index]?.loading ? (
                        <Spin size="small" />
                      ) : (
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => validateEnq(index, each?.remark)}
                        >
                          Verify
                        </span>
                      )
                    }
                  />
                  {enq_status?.[index]?.message && (
                    <div
                      style={{
                        fontSize: 12,
                        marginTop: 4,
                        color: enq_status?.[index]?.valid
                          ? "#237804"
                          : "#cf1322",
                      }}
                    >
                      {enq_status?.[index]?.message}
                    </div>
                  )}
                </React.Fragment>
              ) : each?.charge_type === "Transport Charges" ? (
                <Select
                  className="w-100"
                  onChange={(e) => {
                    onChangeInput(e, index, "remark");
                  }}
                  placeholder="Select transport type"
                  value={each?.remark}
                >
                  <Select.Option value="Standard Delivery">
                    Standard Delivery
                  </Select.Option>
                  <Select.Option value="Express Delivery">
                    Express Delivery
                  </Select.Option>
                  <Select.Option value="Doorstep Delivery">
                    Doorstep Delivery
                  </Select.Option>
                </Select>
              ) : (
                <TextArea
                  value={each.remark}
                  // formatter={(value: any) => `₹ ${value}`}
                  // parser={(value: string) => value.replace("₹", "")}
                  onChange={(e) => {
                    onChangeInput(e.target.value, index, "remark");
                  }}
                  style={{ fontSize: 12 }}
                  placeholder="Remarks"
                />
              )}
            </Form.Item>
            {/* {each?.charge_type === "Transport Charges" && (
              <Space>
                <Checkbox
                  onChange={(ev) => {
                    if (ev.target.checked) {
                      // Make the transporation charge 899 after tax

                      var arr = data?.estimate_additionals;
                      arr[index]["total"] = 899;
                      const tax = arr[index].tax_value;
                      const amount = 899 / (1 + tax * 0.01);
                      arr[index]["amount"] = Number(amount).toFixed(2);
                      arr[index]["remark"] = "Express Delivery";
                      setData("estimate_additionals", [...arr]);
                    }
                  }}
                />
                <span>Express Delivery</span>
              </Space>
            )} */}
          </div>
        ))}
        <Form.Item className="">
          <Button
            type="dashed"
            onClick={() => {
              onAdd();
            }}
            block
            icon={<PlusOutlined />}
          >
            Additional Charges
          </Button>
        </Form.Item>
      </Form>
    </React.Fragment>
  );
};

export default PFIEditAdditionalCharges;
